import { render, staticRenderFns } from "./ProductListByBrand.vue?vue&type=template&id=2d23beec&scoped=true"
import script from "./ProductListByBrand.vue?vue&type=script&lang=js"
export * from "./ProductListByBrand.vue?vue&type=script&lang=js"
import style0 from "./ProductListByBrand.vue?vue&type=style&index=0&id=2d23beec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23beec",
  null
  
)

export default component.exports